import React from "react";
import { withRouter, Redirect, Prompt } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { useFormik } from 'formik'
import * as yup from 'yup'
import moment from "moment";
import {
  Button,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
} from "@material-ui/core";
import { v4 } from "uuid";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as IssueActions from "../actions/IssueActions";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 350,
  },
}));

const validationSchema = yup.object({
  description: yup
    .string('Description')
    .required('Issue description is required'),
})

const AddIssue = (props) => {
  const classes = useStyles();
  const [isDirty, setIsDirty] = React.useState(false)

  const formik = useFormik({
    initialValues: {
      description: "",
      severity: "Minor",
      status: "Open",
    },
    validationSchema: validationSchema,
    onSubmit: (event) => {
      setIsDirty(false);
      //setDidSubmit(true);
      const issue = {
        id: v4(),
        description: formik.values.description,
        severity: formik.values.severity,
        status: formik.values.status,
        createdDate: moment().format('MMMM Do YYYY'),
        lastUpdated: moment().format('MMMM Do YYYY'),
        resolvedDate: null,
        loggedBy: props.users.id,
        lastUpdatedBy: props.users.id,
        loggedByName: props.users.firstName + " " + props.users.lastName,
        lastUpdatedByName: props.users.firstName + " " + props.users.lastName
      };
      //console.log(issue);
      props.actions.addIssue(issue);
      props.history.push("/issue-tracker/issues");
    },
  });

  if (!props.users.isAuthenticated) {
    //showAlert()
    return <Redirect to="/issue-tracker/" />
  }

  return (
    <div style={{ padding: "10px", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <h1>Add Issue</h1>
      <form onSubmit={formik.handleSubmit} onChange={() => setIsDirty(true)} autoComplete="off">
        <TextField
          className={classes.formControl}
          id="description"
          label="Description"
          name="description"
          value={formik.values.description}
          onChange={formik.handleChange}
          error={formik.touched.description && Boolean(formik.errors.description)}
          helperText={formik.touched.description && formik.errors.description}
        />
        <br></br>
        <br></br>
        <FormControl className={classes.formControl}>
          <InputLabel id="severity">Severity</InputLabel>
          <Select
            labelId="Severity"
            id="severity"
            name="severity"
            value={formik.values.severity}
            onChange={formik.handleChange}
          >
            <MenuItem key="1" value={"Critical"}>Critical</MenuItem>
            <MenuItem key="2" value={"Major"}>Major</MenuItem>
            <MenuItem key="3" value={"Minor"}>Minor</MenuItem>
          </Select>
        </FormControl>
        <br></br>
        <br></br>
        <br></br>
        <FormControl component="fieldset">
          <FormLabel component="legend">Status</FormLabel>
          <RadioGroup
            aria-label="Status"
            name="status"
            value={formik.values.status}
            onChange={formik.handleChange}
          >
            <FormControlLabel 
              value="Open" 
              control={<Radio />} 
              label="Open" 
            />
            {/*
            <FormControlLabel
              value="In Progress"
              control={<Radio />}
              label="In Progress"
            />
            <FormControlLabel
              value="Closed"
              control={<Radio />}
              label="Closed"
            />
            */}
          </RadioGroup>
        </FormControl>
        <br></br>
        <br></br>
        <Button fullWidth type="submit" variant="contained" color="primary">
          Submit
        </Button>
      </form>
      <Prompt 
        when={isDirty} 
        message="All changes will be lost, Are you sure you want to continue ?"
      />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    issues: state.issues,
    users: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(IssueActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddIssue));
